import type {Uuid} from "@vesta/common-type-definitions/typeDefinitions";
import {uuidZodValidator} from "@vesta/global-common-typescript/validators/zodValidators";
import {OttopilotOtpWorkspaceCapabilityUdoTemplateKey} from "@vesta/vos-types/modules/workspaceLevel/workspaceCapabilities/ottopilotOtpWorkspaceCapability/domain/OttopilotOtpWorkspaceCapabilityUdoTemplateKey";
import type {WorkspaceCapabilityType} from "@vesta/vos-types/modules/workspaceLevel/workspaceCapabilities/workspaceCapabilities/domain/WorkspaceCapabilityType";
import type {WorkspaceCapabilityUdoTemplateConfiguration} from "@vesta/vos-types/modules/workspaceLevel/workspaceCapabilities/workspaceCapabilities/domain/WorkspaceCapabilityUdoTemplateConfiguration";
import {z as zod} from "zod";

export type OttopilotOtpFields = {isConsumed: boolean; isVerified: boolean; otp: string; phoneNumber: string};
export type OttopilotOtpWorkspaceCapabilityUdoBindings = WorkspaceCapabilityUdoTemplateConfiguration<WorkspaceCapabilityType.ottopilotOtp> & {
    fixedUdoTemplates: {
        [OttopilotOtpWorkspaceCapabilityUdoTemplateKey.otp]: {
            udoAdditionalColumnIds: {
                isConsumed: Uuid;
                isVerified: Uuid;
                otp: Uuid;
                phoneNumber: Uuid;
            };
        };
    };
};
export const ottopilotOtpWorkspaceCapabilityUdoBindingsValidator = zod.strictObject({
    fixedUdoTemplates: zod.strictObject({
        [OttopilotOtpWorkspaceCapabilityUdoTemplateKey.otp]: zod.strictObject({
            udoAdditionalColumnIds: zod.strictObject({isConsumed: uuidZodValidator, isVerified: uuidZodValidator, otp: uuidZodValidator, phoneNumber: uuidZodValidator}),
            udoTemplateId: uuidZodValidator,
        }),
    }),
}) satisfies zod.ZodType<OttopilotOtpWorkspaceCapabilityUdoBindings>;
